import product1 from '../../images/product-1.jpg'
import product2 from '../../images/product-2.jpg'
import product3 from '../../images/product-3.jpg'
import sweet1 from '../../images/sweet-1.jpg'
import sweet2 from '../../images/sweet-2.jpg'
import sweet3 from '../../images/sweet-3.jpg'

export const ProductData = [
    {
        img : product1,
        alt : 'Egg-Noodle',
        name : 'Egg-Noodle',
        desc: `Marinara sause, basil, Italian susage,Roma
        tomaotos`,
        price : '99₫' ,
        button: 'Add to cart',
    },
    {
        img : product2,
        alt : 'Pork-noodle',
        name : 'Pork-Noodle',
        desc: `Hot and spicy Marinara sause, basil, england mix topings`,
        price : '100₫' ,
        button: 'Add to cart',
    },
    {
        img : product3,
        alt : 'Pizza',
        name : 'Indiaana pizza',
        desc: `Indian chilli, country sausage`,
        price : '105₫' ,
        button: 'Add to cart',
    },

]

export const ProductDataDesert = [
    {
        img : sweet1,
        alt : 'Donuts',
        name : 'Doughsious',
        desc: `yummy belgium choclate`,
        price : '99₫' ,
        button: 'Add to cart',
    },
    {
        img : sweet2,
        alt : 'Ice cream',
        name : 'Caramel wonder',
        desc: `frezzing caramel`,
        price : '100₫' ,
        button: 'Add to cart',
    },
    {
        img : sweet3,
        alt : 'BornWin',
        name : 'BornWin',
        desc: `Savage ! Born to win`,
        price : '105₫' ,
        button: 'Add to cart',
    },

]
